<template>
  <div>
    <div class="card"
      style="width:500px;height:550px;margin:0 auto;margin-top:150px;box-shadow: 10px 10px 5px #888888;">
      <div class="card-header" style="font-weight:bold;line-height:20px;">
        二级密码修改
        <span class="float-right" style="display:block;width:20px;line-height:20px;text-align:center;font-size:20px;"
          @click="$router.go(-1)">
          &times;
        </span>
      </div>
      <div class="card-body">
        <el-form label-width="100px" >
          <el-form-item label="新密码："   required>
            <el-input v-model="formDiscount.newPwd1" show-password="true" placeholder="请输入新密码" style="width: 60%" maxlength="6"></el-input>
          </el-form-item>
            <el-form-item label="确认密码：" required>
              <el-input v-model="formDiscount.newPwd2" show-password="true" placeholder="请再次输入新密码" style="width: 60%" maxlength="6"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" required>
            <el-select v-model="formDiscount.phone" placeholder="请选择手机号码" style="width: 60%">
              <el-option v-for="(item, index) of phones" :key="index" :label="item.tel"  :value="item.tel"></el-option>
            </el-select>
            <el-button style="margin-left: 20px" type="primary" :disabled="disabled" size="medium" @click="getCode">{{
              btnText }}</el-button>
          </el-form-item>
          <el-form-item label="验证码：" required>
            <el-input v-model="formDiscount.yzm" placeholder="请输入收到的验证码" style="width: 60%" maxlength="6"></el-input>
          </el-form-item>
        </el-form>
        <p class="text-center">
          <button class="btn btn-primary mt-3" @click="changePassword()">
            确认修改密码
          </button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: '',
      oldPwd: '',
      newPwd1: '',
      newPwd2: '',
      DiscountList: [],
      formDiscount: {
        //设置折扣的参数
        newPwd1:"",
        newPwd2:"",
        phone: "",
        yzm: "",
      },
      phones: [], //手机号列表
      disabled: false, //判断发送验证码是否禁用
      totalCount: 0, //倒计时120S
      success: false,
      isShow: true,
    }
  },
  created() {
    this.isPhones();
  },
  computed: {
    btnText() {
      return this.totalCount != 0
        ? `${this.totalCount}秒再次获取`
        : "获取验证码";
    },
  },
  methods: {
    getCode() {
      const that = this;
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!that.formDiscount.phone) {
        alert("输入的手机号码不能为空！");
      } else if (!reg.test(that.formDiscount.phone)) {
        alert("您输入的手机号码有错误！");
      } else {
        that.getsendMessage();
      }
    },
    getsendMessage: async function () {
      //按钮120秒倒计时
      await this.sendMessage(); //120秒倒计时过后才能调用事件
      if (this.success) {
        this.totalCount = 120;
        this.disabled = true;
        let interval = setInterval(() => {
          this.totalCount--;
          if (this.totalCount === 0) {
            clearInterval(interval);
            this.disabled = false;
          }
        }, 1000);
      }
    },
    // 发送短信
    sendMessage: async function () {
      const that = this;
      await that.$http
        .post("/Dls/addaccount", { phone: that.formDiscount.phone,lx:"ej" })
        .then((response) => {
          //  console.log(response)
          if (response.data.isOk) {
            that.success = true;
            // alert("信息已发送，请注意查收")
            that.$message.success("信息已发送，请注意查收!");
          } else if (!response.data.isOk) {
            if (response.data.errorMessage == -3) {
              alert("发送一次短信可以使用1天，1天内不需要发送新短信");
            } else if (response.data.errorMessage == -4) {
              alert("短信发送失败，请联系管理员！");
            }
          }
        });
    },
    isPhones() {
      const that = this;
      that.$http.post("/Dls/GetPhone", {}).then((response) => {
        if (response.data.isOk) {
          that.phones = response.data.data.rows;
          // console.log(that.phones)
          // $("#myModal_jia").modal();
        } else {
          alert(response.data.message);
        }
      });
    },
    changePassword: async function () {
      if ( this.formDiscount.newPwd1 == "" || this.formDiscount.newPwd2 == "") {
        alert("请输入密码")
      }
      else if (this.formDiscount.newPwd2.length !=6) {
        alert("新密码只能是6位")
      }
      else if (this.formDiscount.newPwd1 !== this.formDiscount.newPwd2) {
        alert("新密码两次输入不一样")
      }
      else {
        const { data: res } = await this.$http.post('api/BgSales/SzEj', {
          dataList:this.formDiscount
        })
        if (res.isok) {
          alert(res.message)
          this.$router.push({ path: '/index' })

        }
      }
    },
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/secondpass.vue